import { Navigate } from 'react-router';
import React, { Fragment } from 'react';
import { LoadingScreen } from 'app/components/ui/loading-screen';
import { ROUTES } from 'app/shared/consts/paths';
import { useUser } from 'app/shared/contexts/user';
import { useApi } from 'app/shared/contexts/api';

interface PrivateProps {
  children: React.ReactNode;
  redirectTo?: string;
}
export const Private = ({ children, redirectTo = ROUTES.ERROR }: PrivateProps): JSX.Element | null => {
  const { user, isLoading } = useUser();
  const authToken = useApi('authToken');

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!authToken || (!isLoading && !user)) {
    // `replace` so an unauth user clicking back from /error doesn't land
    // on the same protected route → re-bounce loop. Matches the catch-all
    // route's behaviour in router.tsx.
    return <Navigate to={redirectTo} replace />;
  }

  // Wrapped in a React Fragment intentionally
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{children}</Fragment>;
};
